import { useQuery } from '@tanstack/react-query';
import {
  fetchPublicationPendingValidations,
  fetchPublicationPublished,
  fetchPublicationRejectedSubmissions,
} from '../api/index.js';

export const KEY_PUBLICATION_PENDING = ['publication', 'pending-validations'] as const;
export const KEY_PUBLICATION_PUBLISHED = ['publication', 'published'] as const;
export const KEY_PUBLICATION_REJECTED = ['publication', 'rejected-submissions'] as const;

export function usePublicationPendingValidations(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY_PUBLICATION_PENDING,
    queryFn: fetchPublicationPendingValidations,
    enabled: options?.enabled ?? true,
  });
}

export function usePublicationRejectedSubmissions(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY_PUBLICATION_REJECTED,
    queryFn: fetchPublicationRejectedSubmissions,
    enabled: options?.enabled ?? true,
  });
}

export function usePublicationPublished(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY_PUBLICATION_PUBLISHED,
    queryFn: fetchPublicationPublished,
    enabled: options?.enabled ?? true,
  });
}
